module.exports = __webpack_public_path__ + "img/icon6.b3d478d1.svg";